import axios from '../../plugins/axios'

export const listUser = ({ commit }, { params } = {}) => {
  return axios.get('/user', { params })
    .then((response) => {
      commit('SET_USERS', { users: response.data })
      return response
    })
    .catch(err => err.response)
}

export const listDriver = ({ commit }, { params } = {}) => {
  return axios.get('/user', { params: { ...params, roles_in: 'driver' } })
    .then(response => response)
    .catch(err => err.response)
}

export const createUser = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.post('/user', payload.data, config)
    .then(response => response)
    .catch(err => err.response)
}

export const deleteUser = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.delete(`/user/${payload.id}`, config)
    .then(response => response)
    .catch(err => err.response)
}

export const updateUser = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.put(`/user/${payload.id}`, payload.data, config)
    .then(response => response)
    .catch(err => err.response)
}

export const validateCodeDriver = (_, { params } = {}) => {
  return axios.get(`/user/validateCode/${params.validateCode}`)
    .then((response) => {
      return response.data
    })
    .catch(err => err.response)
}

export const getDrivers = (_, { params } = {}) => {
  return axios.get('/user?roles_in=driver', { params })
    .then((response) => {
      return response.data
    })
    .catch(err => err.response)
}

export const assignDriverDelivery = (_, payload = {}) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.post('/assign-driver', payload.data, config)
    .then(response => response)
    .catch(err => err.response)
}
